import React from 'react';
import styled from 'styled-components';
import Avatar from './Avatar';

const ActivityFeedContainer = styled.div`
  background-color: var(--card-bg);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  
  h3 {
    font-size: 1.125rem;
    margin: 0 0 1.25rem 0;
    font-weight: 600;
    color: var(--text-primary);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .more-button {
    cursor: pointer;
    color: var(--text-secondary);
    font-size: 1.25rem;
    transform: rotate(90deg);
    margin-right: 0.25rem;
  }
`;

const ActivityItem = styled.div`
  display: flex;
  margin-bottom: 1.25rem;
  align-items: center;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const ActivityContent = styled.div`
  margin-left: 1rem;
  flex: 1;
`;

const ActivityTitle = styled.div`
  font-weight: 500;
  margin-bottom: 0.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--text-primary);
`;

const ActivitySubtitle = styled.div`
  font-size: 0.875rem;
  color: var(--text-secondary);
`;

const ActivityArrow = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--card-highlight-bg);
  color: var(--primary-color);
  font-size: 0.875rem;
  cursor: pointer;
`;

const ViewAllLink = styled.div`
  text-align: center;
  margin-top: 1rem;
  font-size: 0.875rem;
  color: var(--primary-color);
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`;

function ActivityFeed({ activities }) {
  return (
    <ActivityFeedContainer>
      <h3>
        Recent Actions
        <span className="more-button">...</span>
      </h3>
      
      {activities.map((activity, index) => (
        <ActivityItem key={index}>
          <Avatar name={activity.user} imageUrl={activity.avatarUrl} size={36} />
          <ActivityContent>
            <ActivityTitle>
              {activity.title}
            </ActivityTitle>
            <ActivitySubtitle>{activity.subtitle}</ActivitySubtitle>
          </ActivityContent>
          <ActivityArrow>→</ActivityArrow>
        </ActivityItem>
      ))}
      
      <ViewAllLink>Discover All</ViewAllLink>
    </ActivityFeedContainer>
  );
}

export default ActivityFeed;